import React, { Component } from "react";
import { Flex } from "../../styles/GlobalStyle.js";
import {
  TitleOrder,
  TitleProduct,
  SubTitleProduct,
  TagPrice,
  TotalPrice,
  Button,
  Container,
} from "./style/ReceiptOrderStyle.js";
import "react-responsive-modal/styles.css";
import TopBar from "../../components/navbar/TopBar";
import Property from "../../model/property";
import { withTranslation } from "react-i18next";

class ReceiptOrder extends Component {
  state = {
    navbarOpen: false,
    products: [],
    showConfirmation: false,
    totalFinalPrice: 0,
    total: 0,
    subtotal: 0,
    extra_charges: [],
    edit: false,
    dataSelection: [],
  };

  componentDidMount() {
    var products = [];
    var totalFinalPrice = 0;
    let cartItem = Property.getCartItem();
    const dataSelection = Property.getData();
    for (const item of cartItem) {
      const countedPrice = item.item_quantity * item.item_price;
      let product = {
        id: item.uid,
        title: item.item_name,
        quantity: item.item_quantity,
        price: item.item_price,
        subtitle: item.item_subtitle,
        totalPrice: countedPrice,
        item_selection: item.item_selection,
      };
      totalFinalPrice += countedPrice;
      products.push(product);
    }
    this.setState({
      products: products,
      totalFinalPrice: totalFinalPrice,
      dataSelection: dataSelection.store.options,
    });

    const location = this.props.location;
    const productUrl =
      location && location.fromProductList ? location.fromProductList.url : "";
    if (productUrl) {
      Property.setProductURL(productUrl);
    }
  }

  render() {
    const products = this.state.products;
    const currencyCode = Property.getCurrencyCode();
    const title = Property.getPreviousTitle();
    return (
      <div>
        <TopBar
          title={this.props.t("RECEIPT")}
          previousTitle={title ? title : undefined}
        />
        <Container
          className={"sectionContent"}
          id="list-container">
          <Flex
            container
            flex={1}
            margin="24px"
            alignItems="center"
            justifyContent="space-between">
            <TitleOrder>{this.props.t("YOUR_ORDER")}</TitleOrder>
            <Button
              primary
              onClick={() => this.setState({ edit: !this.state.edit })}>
              {this.state.edit ? this.props.t("DONE") : this.props.t("EDIT")}
            </Button>
          </Flex>
          <hr></hr>
          {products.map((item, index) => (
            <Flex key={index}>
              <Flex
                container
                margin="16px 16px"
                alignItems={"flex-start"}>
                <Flex
                  flex={1}
                  margin="0 0 0 16px">
                  <TitleProduct className={"finishTitle"}>
                    {item.title}
                  </TitleProduct>
                  <SubTitleProduct className={"finishSubtitle"}>
                    {item.item_selection}
                  </SubTitleProduct>
                  <Flex
                    container
                    justifyContent="flex-end"
                    margin={"0 16px 0 0"}>
                    <SubTitleProduct
                      className={"finishSubtitle"}>{`${this.props.t("THB")} ${
                      item.price
                    }`}</SubTitleProduct>
                  </Flex>
                </Flex>
              </Flex>
              <hr />
            </Flex>
          ))}
          <hr />

          <Flex
            flex={1}
            container
            margin={"16px 16px"}
            justifyContent={"space-between"}>
            <TagPrice>{this.props.t("SUBTOTAL")}</TagPrice>
            <TagPrice>{`${currencyCode} ${this.state.subtotal}`}</TagPrice>
          </Flex>
          {this.state.extra_charges.map((item, index) => (
            <Flex
              flex={1}
              container
              margin={"16px 16px"}
              justifyContent={"space-between"}
              key={index}>
              <TagPrice>{`${item.title}(${item.value}${
                item.type === "percent" ? "%" : ` ${currencyCode}`
              })`}</TagPrice>
              <TagPrice>{`${currencyCode} ${item.amount}`}</TagPrice>
            </Flex>
          ))}
          <hr />
          <Flex
            flex={1}
            container
            margin={"32px 16px"}
            justifyContent={"space-between"}>
            <TotalPrice>{this.props.t("TOTAL")}</TotalPrice>
            <TotalPrice>{`${currencyCode} ${this.state.total}`}</TotalPrice>
          </Flex>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(ReceiptOrder);
